<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="member-card border rounded mb-lg-0 text-white bg-primary" [ngClass]="{ 'kid-card': isKid }">
    <div class="logo-section">
      <!--Name and ID-->
      <div class="card-id text-start mb-4">
        <div class="mb-2 card-name d-flex align-items-center flex-wrap" *ngIf="memberDetails$ | async as memberDetails">
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </div>
        <div class="d-flex font-size-14">
          <div>{{ ('product.code.' + stripSpaces(memberCard.ProductCode).toLowerCase()) | translate }}</div>
          <div class="px-1">-</div>
          <div>{{ memberCard.MemberId }}</div>
        </div>
      </div>

      <div class="card-logo-container d-flex justify-content-center align-items-center">
        <img
          alt="card logo"
          class="card-logo"
          [src]="(isKid ? 'logo/logo-kid.svg' : 'logo/logo.svg') | contentAssetImage"
          draggable="false"
        />
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center w-100 font-size-14" *ngIf="!isKid">
      <span>{{ 'member.card.balance' | translate : { fgbdefault: 'Balance' } }}</span>
      <span class="fw-bold">{{ combinedCard$ | async | FortressCurrencyPipe }}</span>
    </div>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
